export default {
    ca: {
        title: 'Canviar la visibilitat del mapa',
        message: 'Segur que vols canviar la visibilitat del mapa?',
        messageError: 'No s\'ha pogut canviar la visibilitat el mapa',
        visibilitat: 'Canviar visibilitat mapa'
    },
    es: {
        title: 'Canviar la visibilidad del mapa',
        message: 'Seguro que quieres cambiar la visibilidad del mapa?',
        messageError: 'No se ha podido cambiar la visibilidad del mapa',
        visibilitat: 'Cambiar visibilidad mapa'
    },
    en: {
        title: 'Change the map visibility',
        message: 'Are you sure you want to change the map visibility?',
        messageError: 'Could not change the map visibility',
        visibilitat: 'Change map visibility'
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/visibilitat-modal/visibilitat-modal-translations.js